/**
 * Responsavel
 * @author Simpli CLI generator
 */
import {$, ID, Resource, success} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ResponseSerialize,
  ValidationCNPJ,
  ValidationEmail,
  ValidationMaxLength,
  ValidationPhone,
  ValidationRequired,
} from 'simpli-web-sdk'
import Endereco from '@/model/resource/Endereco'
import ResponsavelFilial from '@/model/resource/ResponsavelFilial'
import ResponsavelSchema from '@/schema/Responsavel.schema'
import {Exclude} from 'class-transformer'

export default class Responsavel extends Resource {
  @Exclude()
  readonly $name: string = 'Responsavel'

  @Exclude()
  readonly $endpoint: string = '/user/me/responsavel{/id}'

  get $schema() {
    return ResponsavelSchema(this)
  }

  get $id() {
    return this.idResponsavelPk
  }
  set $id(val: ID) {
    this.idResponsavelPk = val
  }

  get $tag() {
    return this.nomeFantasia || this.razaoSocial || ''
  }
  set $tag(val: string) {
    this.nomeFantasia = val
  }

  get idEnderecoFk() {
    if (!this.endereco) {
      return 0
    }
    return this.endereco.$id
  }
  set idEnderecoFk(idEnderecoFk: ID) {
    if (!this.endereco) {
      this.endereco = new Endereco()
    }
    this.endereco.$id = idEnderecoFk
  }

  get idFilialFk() {
    if (!this.responsavelFilial) {
      return 0
    }
    return this.responsavelFilial.$id
  }
  set idFilialFk(val: ID | null) {
    if (!val) {
      this.responsavelFilial = null
    } else {
      if (!this.responsavelFilial) {
        this.responsavelFilial = new ResponsavelFilial()
      }
      this.responsavelFilial.$id = val
    }
  }

  @ResponseSerialize(Endereco)
  endereco = new Endereco()

  @Exclude()
  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial: ResponsavelFilial | null = null

  @ResponseSerialize(Responsavel)
  responsavelResponsavel: Responsavel[] = []

  idResponsavelPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(255)
  @ValidationCNPJ()
  cnpj: string = ''

  @Exclude()
  urlLogoEmpresa: string | null = null

  @ValidationMaxLength(255)
  razaoSocial: string | null = null

  @ValidationMaxLength(255)
  nomeFantasia: string | null = null

  @ValidationMaxLength(255)
  nomeContato: string | null = null

  @ValidationMaxLength(255)
  @ValidationPhone()
  telefone: string | null = null

  @ValidationMaxLength(100)
  @ValidationEmail()
  email: string | null = null

  @Exclude()
  dataVencimento: string | null = null

  @Exclude()
  @ValidationRequired()
  jaRedefiniuSenha: boolean = false

  @Exclude()
  dataCriacao: string | null = null

  @Exclude()
  @ValidationRequired()
  criadoPeloAdmin: boolean = false

  @Exclude()
  @ValidationRequired()
  ativo: boolean = false

  @Exclude()
  @ResponseHidden()
  senha: string | null = null

  @Exclude()
  @ResponseHidden()
  senhaAntiga: string | null = null

  @Exclude()
  @ResponseHidden()
  senhaVisualizador: string | null = null

  @Exclude()
  @ResponseHidden()
  senhaAdmin: string | null = null

  @Exclude()
  @ResponseHidden()
  senhaSac: string | null = null

  @Exclude()
  idResponsavelFiltroFilialFk: ID = 0

  @Exclude()
  @ValidationRequired()
  permitirAssociado: boolean = false

  @Exclude()
  @ValidationRequired()
  permitirSerialNumber: boolean = false

  @Exclude()
  permitirRastreamentoDistancia: boolean = false

  exportacao: boolean = false

  @Exclude()
  permitirRoterizacao: boolean = false

  @Exclude()
  permitirFotoInicioCarga: boolean = false

  @Exclude()
  permitirChecklist: boolean = false

  @Exclude()
  permitirChecklistComponente: boolean = false

  @Exclude()
  envioDeContraSenhaCpf: boolean = false

  @Exclude()
  envioDeContraSenhaCnpj: boolean = false

  @Exclude()
  emitenteTransportador: boolean = false

  @Exclude()
  @ValidationRequired()
  receberNotificacoesCarga: boolean = false

  @Exclude()
  @ValidationRequired()
  receberNotificacoesTrajeto: boolean = false

  @Exclude()
  @ValidationRequired()
  permitirDataPrevisao: boolean = false

  @Exclude()
  permitirDevolverNota: boolean = false

  @Exclude()
  @ValidationRequired()
  permitirBotaoNaoEntregarCarga: boolean = false

  @Exclude()
  @ValidationRequired()
  permitirDataEntregaInferiorDataCriacao: boolean = true

  @Exclude()
  @ValidationRequired()
  permitirDataEntregaInferiorDataEmissao: boolean = true

  @Exclude()
  @ValidationRequired()
  permitirFinalizacaoMultiplaApp: boolean = true

  /**
   * Valido somente se for servo
   */
  @Exclude()
  servoIndependente: boolean | null = null

  @Exclude()
  @ValidationRequired()
  auditoriaCepCheckInEmMetros: number = 0

  @Exclude()
  @ValidationRequired()
  auditoriaCepEntregaEmMetros: number = 0

  @Exclude()
  urlImgCabecalho: string | null = null

  @Exclude()
  urlImgRodape: string | null = null

  @Exclude()
  nomeSaraivaFtp: string | null = null

  @Exclude()
  @ValidationRequired()
  limitarConsulta: boolean = false

  @Exclude()
  @ValidationRequired()
  versaoLight: boolean = false

  @Exclude()
  apenasVisualizacao = false

  @Exclude()
  ehFilial = false

  @Exclude()
  permitirUsarCombo: boolean = false

  @Exclude()
  permitirUsarPesquisa: boolean = false

  @Exclude()
  permitirFotoSilenciosa: boolean = false

  @Exclude()
  perguntaPesquisaSatisfacao: string | null = null

  @Exclude()
  perguntaPesquisaSatisfacao2: string | null = null

  @Exclude()
  permitirTransbordo: boolean = false

  @Exclude()
  permitirSms: boolean | null = null

  @Exclude()
  permitirWhatsapp: boolean | null = null

  @Exclude()
  linkBI: string | null = null

  @Exclude()
  idConfiguracaoSlaFk: ID = 0

  @Exclude()
  apiSomenteGoogle: boolean = false

  @Exclude()
  permitirRaioAuditoriaCheckin: boolean = false
  @Exclude()
  raioAuditoriaCheckinMetros: number | null = null

  @Exclude()
  permitirRaioAuditoriaEntrega: boolean = false
  @Exclude()
  raioAuditoriaEntregaMetros: number | null = null
  @Exclude()
  tipoFinalizacaoSucesso: boolean = false

  @Exclude()
  integracaoCorreios: boolean = false

  @Exclude()
  exibirMapaTelaSacPrivado: boolean = false

  @Exclude()
  permitirAlertaNotaAtraso: boolean = false

  @Exclude()
  diasNotificacaoAutomaticaAuditoria: number | null = null

  permitirNotificacaoSmsAtlas: boolean = false

  @Exclude()
  permitirNotificacaoEmailAtlas: boolean = false

  permitirDataReal: boolean = false

  @Exclude()
  permitirCadastrarMesmaDanfe: boolean = false

  @Exclude()
  permitirExcluirNotasFinalizadas: boolean = false

  @Exclude()
  permitirDevolverNotaFinalizadaParaNaoIniciada: boolean = false

  async persistFilial(spinner = 'persistFilial', delay = 0) {
    const fetch = async () => {
      return await this.POST(`/user/me/filtro-filial`, this)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async getResponsavel(id: number|string = '', spinner = 'getResponsavel') {
    const fetch = async () => await this.GET(`/user/me/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async getAssociado(id: number|string = '', spinner = 'getAssociado') {
    const fetch = async () => await this.GET(`/user/me/responsavel-associado/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
